import React, { useState, useEffect } from "react";
import IDialog from "./IDialog";
import { useApiClient } from "../../../contexts/ApiClientContext";
import { AiOutlineExclamationCircle, AiOutlineClose } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import { useAlerts } from "../../../contexts/AlertsContext";
import APIEndPoints from "../../../utils/APIEndPoints";
import StaticPage from "../../../model/StaticPage";
import FormRichTextEditor from "../../common/FormRichTextEditor";

export const EXPLANATION_HEADER = `Before continuing, please be advised that you must consent to the rules governing the use of any data you share through our platform:`;

function LicenseDialog({
  type,
  title = "License Agreement",
  message = "",
  onClose = () => {},
  onCloseDefault = () => {},
  onCancel = () => {},
}: IDialog) {
  // reference to the navigator
  const navigate = useNavigate();
  // reference to the ApiClient instance
  const apiClient = useApiClient();

  const [content, setContent] = useState<StaticPage | null>(null);

  const [loading, setLoading] = useState(true);

  //load record data from the server

  useEffect(() => {
    const loadLic = async () => {
      try {
        const test = await apiClient?.get<StaticPage>({
          url: APIEndPoints.STATIC_PAGES.SEARCHED(message),
          requiresToken: true,
        });
        setContent(test);
      } catch {
        const help = StaticPage.EmptyInstance();
        help.title = "ERROR: required content is not available";
        help.content =
          "Please contact application administrators through email at the following address: contact@cheminova.eu";
        setContent(help);
      }
    };

    loadLic();
  }, []);

  return (
    <div
      tabIndex={-1}
      className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-[calc(100%-0rem)] max-h-full bg-gray-950 bg-opacity-35"
    >
      <div className="relative p-4 w-full max-w-3xl max-h-full">
        <div className="relative bg-white rounded-lg shadow">
          {/* Close */}
          <button
            type="button"
            className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
            onClick={() => {
              onCloseDefault();
              onClose();
            }}
          >
            <AiOutlineClose className="w-3 h-3" />
          </button>

          <div className="p-4 md:p-5 text-center">
            <h2 className="text-lg font-medium text-gray-700 mb-4">
              {content?.title ?? ""}
            </h2>

            <div className="text-left text-sm text-gray-600 border rounded-md p-3 max-h-[40vh] overflow-y-auto mb-6">
              <FormRichTextEditor
                id="license-view"
                value={content?.content ?? ""}
                required={false}
                onChange={() => {}} // ← no-op when readOnly
                readOnly={true}
                modules={{ toolbar: false }}
                className="quill-viewer h-full"
              />
            </div>

            {/* Buttons */}

            <button
              type="button"
              className="py-2.5 px-5 mr-3 text-sm font-medium text-gray-900 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:ring-4 focus:ring-gray-100"
              onClick={() => {
                onCloseDefault();
                onClose();
                onCancel();
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LicenseDialog;
